interface Position {
	x: number;
	y: number;
}

type VibeTier = 'cold' | 'warm' | 'hot' | 'hype';

const SAFE_AREA_WIDTH = 5;
const SAFE_AREA_HEIGHT = 5;

export function getVibeTier(level: number): VibeTier {
	if (level >= 80) return 'hype';
	if (level >= 50) return 'hot';
	if (level >= 25) return 'warm';
	return 'cold';
}

export function isWithinSafeArea({ x, y }: Position): boolean {
	return x >= 0 && x < SAFE_AREA_WIDTH && y >= 0 && y < SAFE_AREA_HEIGHT;
}

export function getInitialSnakePositions(): Position[] {
	const startY = 1; // Start from second row (0-indexed)
	const headX = Math.min(SAFE_AREA_WIDTH - 1, 2);

	return [
		{ x: headX, y: startY },
		{ x: headX - 1, y: startY },
		{ x: Math.max(0, headX - 2), y: startY },
	];
}
